export default {
  线索商户: "Lead Seller",
  商户ID: "Seller ID",
  入驻邮箱: "Email",
  联系电话: "Tel",
  授权店铺: "Authorized shop",
  报名商品数: "Review Product(s)",
  TAP合作店铺: "TAP Partner shop(s)",
  TAP合作商品数: "TAP Product(s)",
  TAP申样数: "TAP Sample Order(s)",
  来源: "Source",
  跟进: "Follow",
  自主入驻: "Self-registered",
  跟进商户: "Follow Up Seller",
  跟进人: "PIC",
  供应链名称: "Supply Chain Name",
  "该店铺已绑定其他供应链，不可重复绑定": "This shop is already linked to another supply chain and cannot be bound again!",
  供应链ID: "Supply Chain ID",
  跟进联系方式: "PIC Contact Info",
  联系邮箱: "Email",
  "Youpik Grow联系电话": "Register Tel",
  店铺名称: "Shop Name",
  店铺号: "Short code",
  是: "Yes",
  否: "No",
  店铺商品数: "Shop Products",
  店铺GMV: "Shop GMV",
  店铺销量: "Shop Sales",
  店铺总订单: "Total Orders",
  SKU订单: "SKU Orders",
  订单均价: "Avg Order Value",
  "该店铺已授权至供应链，不可操作更改！": "This shop is already linked to another supply chain and cannot be bound again!",
  入驻状态: "Register Status",
  未入驻: "Not registered",
  已入驻: "Registered",
  复制入驻链接: "Copy Register Link",
  该商户已入驻: "Already Registered",
  "Youpik Grow账号详情": "Account Details",
  查看: "View",
  入驻时间: "Register Time",
  申样等待处理: "Samples",
  未处理样品申请: "Unprocessed Sample Application",
  超过24hr未处理: "Over 24hr Unprocessed",
  最后一次申样日期: "Last Sample Application Date",
  发货链接: "Shipping Link",
  跟进时间: "Follow-up Time",
  查看发货详情: "View Details",
  复制发货链接: "Copy Link",
  编辑: "Edit",
  商家TAP活动配置: "TAP Campaign Settings",
  活动ID: "Campaign ID",
  活动名称: "Campaign Name",
  活动状态: "Campaign Status",
  进行中: "Ongoing",
  邀约中: "Inviting",
  待邀约: "To Invite",
  不可邀约: "Not Invitable",
  已结束: "Ended",
  报名时间: "Register Period",
  活动时间: "Campaign Period",
  邀约状态: "Invite Status",
  "进行中的联盟营销活动会在Youpik Grow公开展示给所有商家。": "Active campaigns will be publicly shown in Youpik Grow.",
  "活动进行中，还未展示给商家。": "Not yet shown to Sellers.",
  "活动结束，无法展示给商家": "Campaign ended.",
  佣金要求: "Commission Requirement",
  公开佣金: "Open Plan Commission (%)",
  Youpik佣金: "Youpik Commission (%)",
  达人附加佣金: "Extra Creator Bonus (%)",
  "商家在TikTok公开给达人的佣金%": "Commission%",
  "与Youpik合作，商家支付给Youpik的营销佣金。": "Youpik Commission %",
  "在公开佣金之上，商家需支付给达人的额外佣金加成%": "Extra Creator Bonus %",
  寄样要求: "Sample Requirement",
  必须: "Required",
  非必须: "Optional",
  编辑要求: "Edit Requirements",
  暂停邀约: "Pause Invite",
  "在Youpik Grow商家后台暂停邀约该活动": "Pause invite in Youpik Grow",
  "Youpik Grow商家后台将不再展示该活动，你还要继续吗？": "<span style='color: red'>This campaign will no longer be shown in Youpik Grow</span>. Continue?",
  请设置该活动报名需满足的要求: "Please set requirements to invite",
  加入邀约: "Add to Invite",
  注册来源: "Register Source",
  注册邮箱: "Register Email",
  是否合作TAP: "TAP Collaboration",
  全部: "All",
  待发布: "To Publish",
  即将开始: "Starting Soon",
  "仅商家运营可操作！": "Only seller operators allowed!",
  佣金范围错误: "Commission range error",
  商家BD邀请: "BD Invitation",
  "复制成功，请勿将链接发送给错误商家！": "Copy success, please do not send the link to the wrong merchant!"
};
